module.exports = __webpack_public_path__ + "static/img/frequency-b@2x.f8f15be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newUi-icon/frequency-b@2x.png
// module id = rRoH
// module chunks = 96